import { render, staticRenderFns } from "./RemoveBtn.vue?vue&type=template&id=2a078814&scoped=true&"
import script from "./RemoveBtn.vue?vue&type=script&lang=js&"
export * from "./RemoveBtn.vue?vue&type=script&lang=js&"
import style0 from "./RemoveBtn.vue?vue&type=style&index=0&id=2a078814&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a078814",
  null
  
)

export default component.exports